import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M24 42.1c-.5 0-.908-.158-1.225-.475-.317-.317-.475-.725-.475-1.225V12.25L19 15.6c-.333.333-.733.5-1.2.5-.467 0-.867-.167-1.2-.5-.333-.367-.5-.775-.5-1.225 0-.45.167-.842.5-1.175L22.8 7c.2-.2.392-.333.575-.4.183-.067.392-.1.625-.1.233 0 .442.033.625.1s.375.2.575.4l6.2 6.2c.333.333.5.725.5 1.175 0 .45-.167.858-.5 1.225-.333.333-.733.5-1.2.5-.467 0-.867-.167-1.2-.5l-3.3-3.35V40.4c0 .5-.158.908-.475 1.225-.317.317-.725.475-1.225.475Z",
  style: {"fill-rule":"nonzero"},
  transform: "matrix(1 0 0 -1 0 48.6)"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }